import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Puantaj from "./pages/Puantaj";
import Personnel from "./pages/Personnel";
import Reports from "./pages/Reports";
import Users from "./pages/Users";
import GeneralPuantaj from "./pages/GeneralPuantaj";
import CorrectionRequest from "./pages/CorrectionRequest";
import Corrections from "./pages/Corrections";
import Hotels from "./pages/Hotels";
import Layout from "./components/Layout";
import { Toaster } from "sonner";

function Protected({ children, adminOnly, chefOnly }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/puantaj" replace />;
  if (chefOnly && user.role !== "chef") return <Navigate to="/talepler" replace />;
  return <Layout>{children}</Layout>;
}

function RoleRouter() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return user.role === "admin" ? <Dashboard /> : <Navigate to="/puantaj" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><RoleRouter /></Protected>} />
          <Route path="/puantaj" element={<Protected><Puantaj /></Protected>} />
          <Route path="/personel" element={<Protected adminOnly><Personnel /></Protected>} />
          <Route path="/raporlar" element={<Protected adminOnly><Reports /></Protected>} />
          <Route path="/kullanicilar" element={<Protected adminOnly><Users /></Protected>} />
          <Route path="/genel-puantaj" element={<Protected adminOnly><GeneralPuantaj /></Protected>} />
          <Route path="/talepler" element={<Protected adminOnly><Corrections /></Protected>} />
          <Route path="/oteller" element={<Protected adminOnly><Hotels /></Protected>} />
          <Route path="/duzeltme-talebi" element={<Protected chefOnly><CorrectionRequest /></Protected>} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </AuthProvider>
  );
}
